export default __webpack_public_path__ + "static/media/FrameBus.8eb37c6d.svg";